import axios, { AxiosError } from 'axios';
import config from '../config';

export interface ApiError {
  message: string;
  code: string;
  status: number;
}

const api = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const apiError: ApiError = {
      message: 'An unexpected error occurred',
      code: 'UNKNOWN_ERROR',
      status: 500,
    };

    if (error.response) {
      apiError.status = error.response.status;
      apiError.message = error.response.data?.message || error.message;
      apiError.code = error.response.data?.code || 'API_ERROR';

      // Handle specific status codes
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          apiError.code = 'UNAUTHORIZED';
          break;
        case 403:
          apiError.code = 'FORBIDDEN';
          break;
        case 404:
          apiError.code = 'NOT_FOUND';
          break;
        case 422:
          apiError.code = 'VALIDATION_ERROR';
          break;
        case 429:
          apiError.code = 'RATE_LIMIT_EXCEEDED';
          break;
      }
    } else if (error.request) {
      apiError.message = 'Network error - please check your connection';
      apiError.code = 'NETWORK_ERROR';
      apiError.status = 0;
    }

    return Promise.reject(apiError);
  }
);

export default api; 